<!-- SMT贴片用户协议弹框（通用版） -->
<template>
  <el-dialog 
    center
    :title="dialogTitle"
    width="1000px"
    custom-class="submit-protocol-dialog"
    :lock-scroll="false"
    :close-on-click-modal="false"
    :visible="isShow"
    @close="isShow = false"
  >
    <div class="submit-protocol-dialog__content">
      <component :is="protocolComponent" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="isShow = false">同意并继续</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SmtProtocol from './smtProtocol'
import DevelopSmtProtocol from './developSmtProtocol'

export default {
  components: {
    SmtProtocol,
    DevelopSmtProtocol
  },
  props: {
    // 订单类型:0-标准型 1-研发型
    isDevelopOrder: {
      type: Boolean,
      default: 0
    }
  },
  data() {
    return {
      isShow: false,
      // isDevelopOrder: 1
    }
  },
  computed: {
    // 对话框标题
    dialogTitle() {
      return this.isDevelopOrder
        ? '《研发型订单SMT贴片用户协议》' 
        : '《华秋SMT贴片用户协议》'
    },
    // 协议内容组件
    protocolComponent() {
      return this.isDevelopOrder 
        ? 'DevelopSmtProtocol' 
        : 'SmtProtocol'
    }
  },
  methods: {
    open() {
      this.isShow = true
    }
  }
}
</script>

<style lang="scss">
.submit-protocol-dialog {
  .el-dialog__header {
    .el-dialog__title {
      font-size: 18px;
      font-weight: 400 !important;
    }
  }

  .submit-protocol-dialog__content {
    width: 100%;
    height: 380px;
    overflow: auto;
  }
}
</style>
